import matrix from "@/data/seo-matrix.json";

export interface SeoMatrixRow {
  trade: string;
  city: string;
  problem: string;
  problemLabel: string;
  tradeLabel: string;
  cityLabel: string;
  climate: string;
  neighborhoods: string[];
  homeAge: string;
  businessName: string;
}

export const SEO_MATRIX = matrix as SeoMatrixRow[];

const BY_KEY = new Map<string, SeoMatrixRow>();
for (const row of SEO_MATRIX) {
  BY_KEY.set(`${row.trade}/${row.city}/${row.problem}`, row);
}

export function findMatrixRow(
  trade: string,
  city: string,
  problem: string,
): SeoMatrixRow | undefined {
  return BY_KEY.get(`${trade}/${city}/${problem}`);
}

export function relatedProblems(row: SeoMatrixRow, limit = 8): SeoMatrixRow[] {
  return SEO_MATRIX.filter(
    (r) =>
      r.trade === row.trade &&
      r.city === row.city &&
      r.problem !== row.problem,
  ).slice(0, limit);
}

export function problemsForTradeCity(trade: string, city: string): SeoMatrixRow[] {
  return SEO_MATRIX.filter((r) => r.trade === trade && r.city === city);
}